import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// import { Manager, Target, Popper } from "react-popper";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import CustomInput from "components/CustomInput/CustomInput.js";

import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";

import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import { useAuth0 } from "@auth0/auth0-react";

import SweetAlert from "react-bootstrap-sweetalert";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Slide from "@material-ui/core/Slide";
import Button from "components/CustomButtons/Button.js";
import Select from "@material-ui/core/Select";
import Close from "@material-ui/icons/Close";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import * as Constants from "constants.js";
import axios from "axios";

const currentPreventMeetingTitle = Constants.CURRENT_MEETING_TITLE;

const alertOverrides = {
  marginTop: "-100px",
  marginRight: "0px",
  marginBottom: "0px",
  marginLeft: "0px",
};

const useStyles = makeStyles(styles);

const useStylesModal = makeStyles(stylesModal);

const useStylesAlert = makeStyles(stylesAlert);

const { REACT_APP_SERVER_URL } = process.env;

axios.defaults.withCredentials = true;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function HeaderLinks(props) {
  const classesBase = useStyles();
  const classesModal = useStylesModal();
  const classesAlert = useStylesAlert();

  const classes = {
    ...classesBase,
    ...classesModal,
    ...classesAlert,
  };

  const [name, setName] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [institution, setInstitution] = React.useState("");

  const [requestMemberModal, setRequestMemberModal] = React.useState(false);
  const [attendanceModal, setAttendanceModal] = React.useState(false);

  const [votingModal, setVotingModal] = React.useState(false);

  const [typeNumeric, setTypeNumeric] = React.useState("");

  const [accessNumeric, setAccessNumeric] = React.useState("");

  const [typeVoteNumeric, setTypeVoteNumeric] = React.useState("");

  const [alert, setAlert] = React.useState(null);

  const { rtlActive } = props;

  const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover, {
    [classes.dropdownItemRTL]: rtlActive,
  });
  const wrapper = classNames({
    [classes.wrapperRTL]: rtlActive,
  });

  const { loginWithRedirect } = useAuth0();
  const { logout } = useAuth0();
  const { isAuthenticated } = useAuth0();

  const handleLogIn = () => {
    loginWithRedirect();
  };

  const handleLogOut = () => {
    logout({
      returnTo: process.env.REACT_APP_CLIENT_ADDRESS,
    });
  };

  const handleRequestMemberModal = () => {
    setRequestMemberModal(true);
  };

  const handleAttendance = () => {
    setAttendanceModal(true);
  };

  //const handleVoting = () => {
  // setVotingModal(true);
  //};

  const handleSubmitAttendance = async (e) => {
    e.preventDefault();

    const typeCode = typeNumeric == 2 ? Constants.CURRENT_MEETING : "";

    const postValues = {
      email: props.userInfo.email,
      name: props.userInfo.name,
      dateTime: new Date().toISOString(),
      type: typeCode,
    };

    let addAttendance;

    /////NEED to change update profile route to see if project exists and if not create a new project.
    try {
      addAttendance = await axios.post(
        `${REACT_APP_SERVER_URL}/attendance`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        },
      );
    } catch ({ response }) {
      addAttendance = response;
    }
    if (addAttendance.status == 200) {
      successAddAttendance();
      setAttendanceModal(false);
    } else {
      failAddAttendance();
      setAttendanceModal(false);
    }
  };

  const handleSubmitVoting = async (e) => {
    e.preventDefault();

    const roleTypeCode =
      typeVoteNumeric == 2
        ? "vote_chair_2023_emeriaud"
        : typeVoteNumeric == 3
        ? "vote_chair_2023_abusultaneh"
        : typeVoteNumeric == 4
        ? "vote_chair_2023_grunwell"
        : "";

    const postValues = {
      email: props.userInfo.email,
      name: props.userInfo.name,
      dateTime: new Date().toISOString(),
      type: roleTypeCode,
    };

    let addAttendance;

    try {
      addAttendance = await axios.post(
        `${REACT_APP_SERVER_URL}/attendance`, ///I"M USING ATTENDANCE TO HANDLE VOTING ALSO
        {
          ...postValues,
        },
        {
          withCredentials: true,
        },
      );
    } catch ({ response }) {
      addAttendance = response;
    }
    if (addAttendance.status == 200) {
      successAddVote();
      setVotingModal(false);
    } else {
      failAddVote();
      setVotingModal(false);
    }
  };

  const handleSubmitRequest = async (e) => {
    e.preventDefault();

    const postValues = {
      email: props.userInfo.email.toLowerCase(),
      name: name,
      institution: institution,
      about: "",
      type: accessNumeric == "2" ? "research_coordinator" : "member",
      tentative: "true",
      message: message,
    };

    let addUser;
    try {
      addUser = await axios.post(
        `${REACT_APP_SERVER_URL}/users`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        },
      );
    } catch ({ response }) {
      addUser = response;
    }

    if (addUser.status == 200) {
      successAddTentative();
      setRequestMemberModal(false);
      getUpdatedInfo();
    } else {
      console.log(addUser);
      failAddTentative(addUser);
      setRequestMemberModal(false);
    }
  };

  async function getUpdatedInfo() {
    props.reloadImagesUsersCallBack(true);
  }

  const hideAlert = () => {
    setAlert(null);
  };

  const successAddAttendance = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
          setAttendanceModal(false);
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Attendance Recorded!
      </SweetAlert>,
    );
  };

  const successAddVote = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
          setVotingModal(false);
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Vote Recorded!
      </SweetAlert>,
    );
  };

  const failAddAttendance = (errorMessage) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage ? errorMessage : "Something Went Wrong!"}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        Attendance not added!
      </SweetAlert>,
    );
  };

  const failAddVote = (errorMessage) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage ? errorMessage : "Something Went Wrong!"}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        Vote not added!
      </SweetAlert>,
    );
  };

  const successAddTentative = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
          setRequestMemberModal(false);
        }}
        onCancel={() => {
          hideAlert();
          setRequestMemberModal(false);
        }}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Provisional Membership Granted!
      </SweetAlert>,
    );
  };

  const failAddTentative = (error) => {
    const errorMessage =
      error && error.data.messages
        ? error.data.messages.databaseError
        : "Error";

    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage}
        onConfirm={() => {
          hideAlert();
          setRequestMemberModal(false);
        }}
        onCancel={() => {
          hideAlert();
          setRequestMemberModal(false);
        }}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        Request Not Submitted!
      </SweetAlert>,
    );
  };

  const access = props.userInfo && props.userInfo.access;

  return (
    <div>
      {alert}
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={requestMemberModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setRequestMemberModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => {
              setRequestMemberModal(false);
            }}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>Request Access</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <form onSubmit={handleSubmitRequest}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          Select Access Type
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          classes={{
                            select: classes.select,
                          }}
                          inputProps={{
                            name: "simpleSelect",
                            id: "accessNumeric",
                            value: accessNumeric,
                            onChange: (event) => {
                              setAccessNumeric(event.target.value);
                            },
                          }}
                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classes.selectMenuItem,
                            }}
                          >
                            Select Access Type
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="2"
                          >
                            Research Coordinator
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="3"
                          >
                            Member
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Name *"
                        id="name"
                        success={name.length > 0}
                        error={!name.length > 0}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: name,
                          onChange: (event) => {
                            setName(event.target.value);
                          },
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Institution *"
                        id="institution"
                        success={institution.length > 0}
                        error={!institution.length > 0}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: institution,
                          onChange: (event) => {
                            setInstitution(event.target.value);
                          },
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText={
                          "Message for reviewer * (Max Characters: 1000)"
                        }
                        id="message"
                        success={message.length > 0}
                        error={!message.length > 0}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: message,
                          onChange: (event) => {
                            setMessage(event.target.value);
                          },
                          multiline: true,
                          rows: 5,
                          maxLength: 1000,
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <Button
                    color="info"
                    className={classes.updateProfileButton}
                    type="submit"
                    disabled={
                      !(
                        name.length > 0 &&
                        message.length > 0 &&
                        institution.length > 0
                      )
                    }
                  >
                    Submit Request
                  </Button>
                </form>
              </GridItem>
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button
            onClick={() => {
              setRequestMemberModal(false);
            }}
            color="rose"
            round
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={attendanceModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setAttendanceModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => {
              setAttendanceModal(false);
            }}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>Record Attendance</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <form onSubmit={handleSubmitAttendance}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          Select Attendance Type
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          classes={{
                            select: classes.select,
                          }}
                          inputProps={{
                            name: "simpleSelect",
                            id: "typeNumeric",
                            value: typeNumeric,
                            onChange: (event) => {
                              setTypeNumeric(event.target.value);
                            },
                          }}
                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classes.selectMenuItem,
                            }}
                          >
                            Select Type
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="2"
                          >
                            {currentPreventMeetingTitle}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                  <br></br>

                  <Button
                    color="info"
                    className={classes.updateProfileButton}
                    type="submit"
                    disabled={typeNumeric < 2}
                  >
                    Submit Attendance
                  </Button>
                </form>
              </GridItem>
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button
            onClick={() => {
              setAttendanceModal(false);
            }}
            color="rose"
            round
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={votingModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setVotingModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => {
              setTypeVoteNumeric("1");
              setVotingModal(false);
            }}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            Submit Vote for PREVENT Chair-Elect
          </h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <form onSubmit={handleSubmitVoting}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          Select Candidate To View Bio
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          classes={{
                            select: classes.select,
                          }}
                          inputProps={{
                            name: "simpleSelect",
                            id: "typeNumeric",
                            value: typeVoteNumeric,
                            onChange: (event) => {
                              setTypeVoteNumeric(event.target.value);
                            },
                          }}
                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classes.selectMenuItem,
                            }}
                          >
                            Select Candidate
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="2"
                          >
                            Dr. Guillaume Emeriaud, MD, PhD
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="3"
                          >
                            Dr. Samer Abu-Sultaneh, MD, FAAP, FCCM
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="4"
                          >
                            Dr. Jocelyn R. Grunwell, MD, PhD
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                  <br></br>
                  {typeVoteNumeric == 2 && (
                    <div>
                      <h5>
                        Dr Guillaume Emeriaud MD PhD is a pediatric intensivist
                        and researcher from Sainte- Justine Hospital in
                        Montreal, Canada. He completed his medical training in
                        France (in Grenoble) and at the Universit de Montral,
                        and a PhD in Modeling of Living Systems at the
                        Universit J Fourier, in France. He moved to Canada in
                        2009, where he is a Clinical Professor at the Department
                        of pediatrics of Universit de Montral, and supported
                        as a Senior Clinical Scientist by the Fonds de Recherche
                        du Qubec en Sant. He is also the Director of the Axis
                        Infectious Disease and Acute Care of the Ste-Justine
                        Research Center. His main research program aims to
                        improve patient-ventilator interactions during
                        ventilation support, with a specific interest on
                        respiratory muscle monitoring, NAVA, and non-invasive
                        ventilation. He is involved in the PALISI since 2010,
                        and active in several subgroups dealing with ventilatory
                        support, including PREVENT and NEAR4Kids (both since
                        2010). He participated actively or led several
                        multicenter initiatives in that context, especially in
                        the field of NIV. He was one of the co-chairs of
                        PALICC-2 (with Dr Y Lopez-Fernandez and Dr R Khemani)
                        from 2020 to 2022.
                      </h5>
                    </div>
                  )}

                  {typeVoteNumeric == 3 && (
                    <div>
                      <h5>
                        Samer Abu-Sultaneh, MD, FAAP, FCCM is a pediatric
                        intensivist, associate professor of clinical pediatrics,
                        and the medical director of respiratory care at Riley
                        Hospital for Children at Indiana University
                        Health/Indiana University School of Medicine. He is the
                        past co-chair for the SCCM ICU liberation committee.
                        Samers academic focus is respiratory-driven
                        inter-professional quality improvement management
                        protocols and implementing ICU liberation in pediatric
                        ICUs, especially pediatric ventilator liberation. Samer
                        is involved in many PREVENT sponsored studies like
                        computerized decision support (CDS) for PARDS and
                        LongVentKids. He was the co-chair of the pediatric
                        ventilator liberation guidelines. Currently he is
                        co-leading the implementation study of the guidelines
                        (VentLib4Kids). He spearheaded the establishment of the
                        pediatric critical asthma workgroup of PREVENT which is
                        conducting observational studies including a point
                        prevalence study. He is also the co-chair for the
                        AARC/PALISI pediatric critical asthma clinical practice
                        guidelines. His goal as chair of PREVENT is to continue
                        maintaining the great track record of the subgroup by
                        attracting a diverse group of talented junior and
                        mid-career multi-professional investigators (physicians,
                        nurses, advance care providers, PharmD, informational
                        technologists, and respiratory therapists) to conduct
                        more studies related to respiratory disease/failure
                        including a platform trial.
                      </h5>
                    </div>
                  )}

                  {typeVoteNumeric == 4 && (
                    <div>
                      <h5>
                        Dr. Jocelyn R. Grunwell, MD, PhD is an Associate
                        Professor of Pediatrics in the Division of Critical Care
                        Medicine at Emory University and Childrens Healthcare
                        of Atlanta. Dr. Grunwell completed her undergraduate
                        studies in chemistry at Harvard University. She then
                        attended graduate school at the University of
                        California, Berkeley where she received a PhD in
                        Bio-organic Chemistry. After completing a post-doctoral
                        fellowship in biochemistry at the University of
                        California San Francisco, where she was a Damon Runyon
                        post-doctoral fellow, she attended the Stanford
                        University School of Medicine. She completed her
                        Pediatrics Residency at Emory University in 2012. She
                        was the Assistant Program Director (Chief Resident) for
                        the Emory Pediatrics Residency program from 2012 - 2013.
                        She completed her subspecialty fellowship training in
                        pediatric critical care medicine at Emory in 2017 where
                        she was a T32 post-doctoral fellow. From 2018 - 2020,
                        Dr. Grunwell was an Atlanta Pediatric K12 Scholar. In
                        2020, Dr. Grunwell was awarded Junior Faculty Researcher
                        of the Year. She is currently a NHLBI K23 awardee. Dr.
                        Grunwell completed the postgraduate coursework for the
                        Master of Science in Clinical and Translational Research
                        (MSCR) degree at Emory in 2022. In 2022, Dr. Grunwell
                        became the Research Director for the Division of
                        Pediatric Critical Care Medicine. Dr. Grunwells
                        research focuses on the airway immune response in
                        children who are at risk for developing and who are
                        diagnosed with acute respiratory distress syndrome. She
                        has a research program in immunophenotyping and
                        determining patient-reported outcomes following
                        life-threatening asthma exacerbations. She collaborates
                        with engineers at the Georgia Institute of Technology to
                        develop a lung-in-a-dish model and data scientists and
                        machine learning experts at Emory/Georgia Tech to
                        discover transcriptomic and metabolomic signatures of
                        pediatric ARDS. In addition to her translational
                        research, she participates in the Pediatric Acute Lung
                        Injury and Sepsis Investigators (PALISI) network and
                        collaborates on multi-center observational and clinical
                        trials to improve the care of critically ill children
                        with ARDS (LEOPARDS), influenza (PICFLU2), sepsis
                        (PROMPT-BOLUS), and multiple organ dysfunction
                        (PARADIGM, TROPICS). She is a member of the SCCM
                        Discover Research Network and the Pediatric Acute Lung
                        Injury Consensus Conference (PALICC-2) guideline
                        committee.
                      </h5>
                    </div>
                  )}

                  <Button
                    color="info"
                    className={classes.updateProfileButton}
                    type="submit"
                    disabled={typeVoteNumeric < 2}
                  >
                    Submit Vote For This Candidate
                  </Button>
                </form>
              </GridItem>
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button
            onClick={() => {
              setTypeVoteNumeric("");
              setVotingModal(false);
            }}
            color="rose"
            round
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <div style={{ display: "flex" }}>
        {/*        <div className={wrapper}>
          <MenuList role="menu">
            {access > 3 && (
              <MenuItem onClick={handleVoting} className={dropdownItem}>
                {"Voting"}
              </MenuItem>
            )}
          </MenuList>
        </div> */}

        <div className={wrapper}>
          <MenuList role="menu">
            {access > 2 && (
              <MenuItem onClick={handleAttendance} className={dropdownItem}>
                {"Attendance"}
              </MenuItem>
            )}
          </MenuList>
        </div>
        <div className={wrapper}>
          <MenuList role="menu">
            {access == 3 && (
              <MenuItem
                onClick={handleRequestMemberModal}
                className={dropdownItem}
              >
                {"Request Access"}
              </MenuItem>
            )}
          </MenuList>
        </div>
        <div className={wrapper}>
          <MenuList role="menu">
            {!isAuthenticated && (
              <MenuItem onClick={handleLogIn} className={dropdownItem}>
                {"Log In / Sign Up"}
              </MenuItem>
            )}

            {isAuthenticated && (
              <MenuItem onClick={handleLogOut} className={dropdownItem}>
                {"Log Out"}
              </MenuItem>
            )}
            {access == 2 && (
              <h4
                style={{
                  color: "red",
                  backgroundColor: "white",
                  fontWeight: "bold",
                }}
              >
                Please check email from prevent@redvent.net and verify account
                then refresh the page to enable account features. If you do not
                receive an email please write to jhotz@chla.usc.edu to complete
                verification.
              </h4>
            )}
          </MenuList>
        </div>
      </div>
    </div>
  );
}

HeaderLinks.propTypes = {
  userInfo: PropTypes.Object,
  rtlActive: PropTypes.bool,
  reloadImagesUsersCallBack: PropTypes.func,
};

